import { ResultsItem, ResultSubItem, IconContent } from '../../../features/Report';
import { Tooltip } from '../../../components';

const formatInt = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return '';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.trunc(num));
};

export const SocialProfilesSection = ({ id, data }) => {
  const defaultCriteria = { status: 'error', iconType: 'error', isEmpty: true, message: '', importance: { level: 0, text: '' }, solvability: { level: 0, text: '' } };

  const socialMediaEngagement = data?.socialMediaEngagement || defaultCriteria;
  const facebookPage = data?.facebookPage || defaultCriteria;
  const twitterAccount = data?.twitterAccount || defaultCriteria;
  const instagramAccount = data?.instagramAccount || defaultCriteria;
  const linkedinAccount = data?.linkedinAccount || defaultCriteria;

  const errorCount = data?.errorCount || 0;
  const toImproveCount = data?.toImproveCount || 0;

  return (
    <ResultsItem 
      id={id}
      title="Social Profiles" 
      tooltip="Your social profiles are an important part of your online presence. They can help you build brand awareness and help drive traffic to your website."
      errorCount={errorCount}
      toImproveCount={toImproveCount}
    >
      <ResultSubItem
        title="Social Media Engagement"
        tooltip="Engagement metrics on social media platforms."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={socialMediaEngagement?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!socialMediaEngagement?.isEmpty && socialMediaEngagement?.data ? (
              <ul className="social-icons-list">
                {Number(socialMediaEngagement?.data?.facebookShares || 0) > 0 && (
                  <li className="social-icons-list__item">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.3776 5.70757V3.57782C12.3776 3.09805 12.9078 2.83964 13.268 3.10864L13.3297 3.16165L17.8268 7.58283C18.0367 7.78916 18.0558 8.12058 17.8841 8.34968L17.8269 8.41512L13.3298 12.8377C12.992 13.1699 12.4429 12.9566 12.3829 12.5039L12.3776 12.4216V10.3261L12.1199 10.3493C10.3196 10.5417 8.59416 11.3728 6.93261 12.8564C6.54318 13.2042 5.94067 12.8754 6.00472 12.3501C6.50344 8.25989 8.59039 6.00547 12.153 5.72268L12.3776 5.70757ZM5.5 4C4.11929 4 3 5.11929 3 6.5V14.5C3 15.8807 4.11929 17 5.5 17H13.5C14.8807 17 16 15.8807 16 14.5V13.5C16 13.2239 15.7761 13 15.5 13C15.2239 13 15 13.2239 15 13.5V14.5C15 15.3284 14.3284 16 13.5 16H5.5C4.67157 16 4 15.3284 4 14.5V6.5C4 5.67157 4.67157 5 5.5 5H8.5C8.77614 5 9 4.77614 9 4.5C9 4.22386 8.77614 4 8.5 4H5.5Z" fill="#6E7B81"/>
                    </svg>
                    <span>Facebook Shares: <span className="social-icons-list__value">{formatInt(socialMediaEngagement?.data?.facebookShares)}</span></span>
                  </li>
                )}

                {Number(socialMediaEngagement?.data?.facebookComments || 0) > 0 && (
                  <li className="social-icons-list__item">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.5 2C5.28015 2 4.26436 2.87367 4.04422 4.02941C4.1934 4.01001 4.34553 4 4.5 4H12.5C14.433 4 16 5.567 16 7.5V12.95C17.1411 12.7184 18 11.7095 18 10.5V6C18 3.79086 16.2091 2 14 2H6.5ZM4.5 5C4.32877 5 4.16156 5.01722 4 5.05001C2.85888 5.28164 2 6.29052 2 7.5V13.5C2 14.8807 3.11929 16 4.5 16H5V17.0284C5 17.8418 5.91937 18.3149 6.58124 17.8421L9.16023 16H12.5C13.8807 16 15 14.8807 15 13.5V7.5C15 6.11929 13.8807 5 12.5 5H4.5Z" fill="#6E7B81"/>
                    </svg>
                    <span>Facebook Comments: <span className="social-icons-list__value">{formatInt(socialMediaEngagement?.data?.facebookComments)}</span></span>
                  </li>
                )}

                {Number(socialMediaEngagement?.data?.facebookReactions || 0) > 0 && (
                  <li className="social-icons-list__item">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.5709 6.49976C17.41 6.31743 17.2121 6.17141 16.9905 6.07142C16.7688 5.97142 16.5284 5.91973 16.2852 5.91978H12.2854V4.77696C12.2854 4.01923 11.9843 3.29253 11.4485 2.75673C10.9127 2.22093 10.186 1.91992 9.42831 1.91992C9.32216 1.91985 9.21808 1.94934 9.12775 2.00511C9.03742 2.06087 8.96441 2.14069 8.9169 2.23563L6.21842 7.63401H3.14282C2.83972 7.63401 2.54904 7.75441 2.33472 7.96873C2.1204 8.18305 2 8.47373 2 8.77682V15.0623C2 15.3654 2.1204 15.6561 2.33472 15.8704C2.54904 16.0847 2.83972 16.2051 3.14282 16.2051H15.4281C15.8457 16.2053 16.2491 16.053 16.5623 15.7768C16.8756 15.5006 17.0773 15.1195 17.1295 14.7052L17.9866 7.84829C18.017 7.60688 17.9956 7.36178 17.9239 7.12926C17.8523 6.89675 17.7319 6.68216 17.5709 6.49976ZM3.14282 8.77682H5.99986V15.0623H3.14282V8.77682Z" fill="#6E7B81"/>
                    </svg>
                    <span>Facebook Likes: <span className="social-icons-list__value">{formatInt(socialMediaEngagement?.data?.facebookReactions)}</span></span>
                  </li>
                )}

                {Number(socialMediaEngagement?.data?.pinterest || 0) > 0 && (
                  <li className="social-icons-list__item">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 2C5.581 2 2 5.581 2 10C2 13.313 4.013 16.153 6.886 17.329C6.858 16.781 6.881 16.124 7.017 15.529C7.165 14.892 7.999 11.413 7.999 11.413C7.999 11.413 7.746 10.905 7.746 10.154C7.746 8.977 8.429 8.098 9.279 8.098C10.001 8.098 10.349 8.641 10.349 9.293C10.349 10.019 9.887 11.106 9.649 12.102C9.451 12.939 10.069 13.621 10.895 13.621C12.387 13.621 13.54 12.05 13.54 9.784C13.54 7.693 12.039 6.231 9.897 6.231C7.404 6.231 5.937 8.1 5.937 10.035C5.937 10.76 6.216 11.536 6.565 11.958C6.639 12.049 6.649 12.127 6.622 12.236C6.559 12.499 6.417 13.073 6.389 13.191C6.353 13.345 6.268 13.378 6.12 13.311C5.251 12.907 4.706 11.64 4.706 10.623C4.706 7.941 6.654 5.478 10.325 5.478C13.284 5.478 15.582 7.585 15.582 10.406C15.582 13.407 13.692 15.823 11.067 15.823C10.224 15.823 9.432 15.386 9.159 14.866C9.159 14.866 8.741 16.457 8.638 16.825C8.454 17.44 7.957 18.21 7.592 18.692C8.333 18.921 9.149 19.046 10 19.046C14.419 19.046 18 15.465 18 11.046C18 6.627 14.419 3.046 10 3.046V2Z" fill="#6E7B81"/>
                    </svg>
                    <span>Pinterest: <span className="social-icons-list__value">{formatInt(socialMediaEngagement?.data?.pinterest)}</span></span>
                  </li>
                )}
              </ul>
            ) : (
              <p className="text-primary">
                {socialMediaEngagement?.message || 'No Social Media Engagement were found.'}
              </p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Facebook Page"
        tooltip="Name and URL associated with your Facebook account."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={facebookPage?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!facebookPage?.isEmpty && facebookPage?.data ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <p className="text-primary">{facebookPage?.data?.name || ''}</p>
                <p className="text-secondary">{facebookPage?.data?.url || ''}</p>
              </div>
            ) : (
              <p className="text-primary">{facebookPage?.message || 'No Facebook Page was found.'}</p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Twitter Account"
        tooltip="Name and URL associated with your Twitter account."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={twitterAccount?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!twitterAccount?.isEmpty && twitterAccount?.data ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <p className="text-primary">{twitterAccount?.data?.name || ''}</p>
                <p className="text-secondary">{twitterAccount?.data?.url || ''}</p>
              </div>
            ) : (
              <p className="text-primary">{twitterAccount?.message || 'No Twitter Account was found.'}</p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Instagram Account"
        tooltip="Name and URL associated with your Instagram account."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={instagramAccount?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!instagramAccount?.isEmpty && instagramAccount?.data ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <p className="text-primary">{instagramAccount?.data?.name || ''}</p>
                <p className="text-secondary">{instagramAccount?.data?.url || ''}</p>
              </div>
            ) : (
              <p className="text-primary">{instagramAccount?.message || 'No Instagram Account was found.'}</p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="LinkedIn Account"
        tooltip="Name and URL associated with your LinkedIn account."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={linkedinAccount?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!linkedinAccount?.isEmpty && linkedinAccount?.data ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <p className="text-primary">{linkedinAccount?.data?.name || ''}</p>
                <p className="text-secondary">{linkedinAccount?.data?.url || ''}</p>
              </div>
            ) : (
              <p className="text-primary">{linkedinAccount?.message || 'No LinkedIn Account was found.'}</p>
            )}
          </IconContent>
        }
      />
    </ResultsItem>
  );
};
